import React, {Component} from 'react';
import {gpn} from "../GPN"
import Icon from "./MUI/Icon";
import config from "../config";

class SideBar extends Component {

    state = {
        items: [
            {t: "داشبورد", i: "gauge", p: "/dashboard", a: "dashboard"},
            {t: "ادمین ها", i: "user", p: "/admins", a: "admin"},
            {t: "متخصص ها", i: "user-tie", p: "/experts", a: "expert"},
            {t: "کاربران", i: "person", p: "/users", a: "user"},
            {t: "دسته بندی ها", i: "list", p: "/categories", a: "category"},
            {t: "خدمات", i: "list-timeline", p: "/services", a: "service"},
            {t: "سفارشات", i: "sort", p: "/orders", a: "order"},
            {t: "محله ها", i: "chart-area", p: "/regions", a: "region"},
            {t: "پرداخت ها", i: "dollar", p: "/payments", a: "payment"},
            {t: "چت ها", i: "comment-alt-medical", p: "/chats", a: "chats"}
        ]
    };

    render() {
        const {permissions} = this.props;
        const {items} = this.state;
        return (
            <div className="col-md-4">
                <aside className="sidebar">
                    {
                        items.map((it, i) =>
                            config.hasAccess(permissions, it.a) ?
                                <div className="side-item"
                                     key={"side" + i}
                                     onClick={() => this.props.navigate(it.p)}><Icon i={it.i}/>{it.t}</div>
                                : null
                        )
                    }
                </aside>
            </div>
        );
    }
}

export default gpn(SideBar);